/**
 * town_tabs.ts — the Town window's tab registry (TOWN LIFE, 2026-09-24). Each module that owns a part of town life
 * (the races, the posts, fireworks and camps …) registers its tab; the Town window lists them in `order`.
 * globalThis-backed: the dev graph can resolve a module twice, a shared store is instance-proof.
 */
export interface TownTab { key: string; label: string; order: number; render(host: HTMLElement): void }

function store(): TownTab[] {
  const g = globalThis as unknown as { __atlasTownTabs?: TownTab[] };
  if (!g.__atlasTownTabs) g.__atlasTownTabs = [];
  return g.__atlasTownTabs;
}

export function registerTownTab(t: TownTab): void {
  const s = store();
  const i = s.findIndex((x) => x.key === t.key);
  if (i >= 0) s[i] = t; else s.push(t);
  s.sort((a, b) => a.order - b.order);
}

export function townTabs(): TownTab[] { return store(); }
